import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link } from '@mui/material';
import { AntibodiesListView } from 'components/AntibodiesList/AntibodiesListView';
import { MiniDrawerWithContext } from 'components/Layout/drawer';
import 'components/AntibodiesList/styles.css';
import { useAppContext } from 'services/context';
import highResolutionLogo from 'images/logos/logoHighResolution.png';
import { useAntibodiesPageStyles } from 'components/AntibodiesList/antibodiesListStyles';
import { IHC_ANTIBODIES_INDEX_URL } from 'constants/urls';

export const AntibodiesPage = () => {
  const { isLoggedIn } = useAppContext();
  const { isAuthenticated } = useAuth0();

  const { classes } = useAntibodiesPageStyles();

  return isLoggedIn || isAuthenticated ? (
    <MiniDrawerWithContext header="Antibodies List" withoutBackground>
      <div className={classes.antibodiesListWrapper}>
        <AntibodiesListView />
      </div>
    </MiniDrawerWithContext>
  ) : (
    <div className={classes.root}>
      <main className={classes.content}>
        <div className={classes.logoWrapper}>
          <a href="https://www.histowiz.com">
            <img
              className={classes.logo}
              src={highResolutionLogo}
              alt="HistoWiz Logo"
            />
          </a>
        </div>
        {/* The grid below links with buttons, not anchors, so crawlers need this index. */}
        <Box mb={2} display="flex" justifyContent="flex-end">
          <Link component={RouterLink} to={IHC_ANTIBODIES_INDEX_URL}>
            Browse all IHC antibodies
          </Link>
        </Box>
        <AntibodiesListView />
      </main>
    </div>
  );
};
